/* eslint-disable @stylistic/jsx-child-element-spacing */
/* eslint-disable @stylistic/max-len */
import { Button } from '@sgcmpteltd/uikit-react';
import {
  BUTTON_COLOR_RED,
  BUTTON_VARIANT_OUTLINED,
} from '@sgcmpteltd/uikit-react/components/button';
import Image from 'next/image';
import { useRouter } from 'next/navigation';

import styles from './styles.module.scss';

interface UnlockRewardsSectionProps {
  userEmail?: string;
  isLoggedIn: boolean;
  quickSignUp: () => void;
  isFetchingQuickSignUp: boolean;
  isLinkResent: boolean;
}

export const UnlockRewardsSection: React.FC<UnlockRewardsSectionProps> = ({
  userEmail,
  isLoggedIn,
  quickSignUp,
  isFetchingQuickSignUp,
  isLinkResent,
}) => {
  const router = useRouter();

  const handleRewardsRedirect = () => {
    router.push(`${process.env.NEXT_PUBLIC_SGCM_MS_SITE_ORIGIN}/account/rewards`);
  };

  if (isLoggedIn) {
    return (
      <div className={styles.rewardsSection}>
        <div className={styles.contentContainer}>
          <Image
            alt="Rewards Icon"
            height={54}
            src={`${process.env.NEXT_PUBLIC_SGCM_MEDIA_ORIGIN}/public/dashboard/dashboard-gift.svg`}
            width={50} />
          <div className={styles.textContainer}>
            <div className={styles.rewardsTitle}>Unlock Your Rewards</div>
            <div className={styles.rewardsDesc}>
              Enjoy exclusive perks, special offers, and much more, available now just for you.
            </div>
          </div>
        </div>
        <Button
          className={styles.rewardsButton}
          color={BUTTON_COLOR_RED}
          variant={BUTTON_VARIANT_OUTLINED}
          onClick={handleRewardsRedirect}>
          View My Rewards
        </Button>
      </div>
    );
  }

  return (
    <div className={styles.rewardsSection}>
      <div className={styles.contentContainer}>
        <div className={styles.rewardsIcon}>
          <Image
            alt="Rewards Icon"
            height={54}
            src={`${process.env.NEXT_PUBLIC_SGCM_MEDIA_ORIGIN}/public/dashboard/dashboard-gift.svg`}
            width={50} />
        </div>
        <div className={styles.textContainer}>
          <div className={styles.rewardsTitle}>Check Your Email & Unlock Rewards</div>
          <div className={styles.rewardsDesc}>
            A special link was sent to
            {' '}
            <span className={styles.userEmail}>
              {userEmail}
            </span>
            . Check your inbox to enjoy exclusive member perks!
          </div>
          <button
            className={styles.resendLink}
            disabled={isFetchingQuickSignUp}
            onClick={quickSignUp}>
            {isFetchingQuickSignUp ? 'Sending...' : 'Resend Special Link'}
          </button>
          {isLinkResent
          && <p className={styles.resendLinkDesc}>The special link has been resent. Please check back your email!</p>}
        </div>
      </div>
      <Button
        className={styles.rewardsButton}
        color={BUTTON_COLOR_RED}
        variant={BUTTON_VARIANT_OUTLINED}
        onClick={handleRewardsRedirect}>
        Login To View My Rewards
      </Button>
    </div>
  );
};
